/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise'
import { OpenAPI } from '../core/OpenAPI'
import { request as __request } from '../core/request'

export class PdfGenerationApiService {
  /**
   * Method for generating a pdf file with data for a quotation summary - internal approval
   * @param id
   * @returns binary OK
   * @throws ApiError
   */
  public static quotationSummaryInternalApprovalPdfGeneration(
    id: string
  ): CancelablePromise<Blob> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/quotation-summary-internal-approval-pdf',
      query: {
        id: id
      },
      errors: {
        404: 'Not Found'
      },
      responseHeader: 'Content-Disposition'
    })
  }

  /**
   * Method for generating a pdf file with data for a quotation summary - sales support
   * @param id
   * @returns binary OK
   * @throws ApiError
   */
  public static quotationSummarySalesSupportPdfGeneration(
    id: string
  ): CancelablePromise<Blob> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/quotation-summary-sales-support-pdf',
      query: {
        id: id
      },
      errors: {
        404: 'Not Found'
      },
      responseHeader: 'Content-Disposition'
    })
  }

  /**
   * Method for generating a pdf file with data for a quotation summary - customer quote
   * @param id
   * @returns binary OK
   * @throws ApiError
   */
  public static quotationSummaryCustomerQuotePdfGeneration(
    id: string
  ): CancelablePromise<Blob> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/quotation-summary-customer-quote-pdf',
      query: {
        id: id
      },
      errors: {
        404: 'Not Found'
      },
      responseHeader: 'Content-Disposition'
    })
  }
}
